module.exports = __webpack_public_path__ + "img/zonalMap.f0300140.png";